module.exports = __webpack_public_path__ + "a869cdaf5779a367879b61873d089322.png";